import React from 'react';
import { motion } from 'framer-motion';
import { Users, MapPin, MessageSquare, DollarSign, ShieldCheck, Clock } from 'lucide-react';
export function WhyChooseUs() {
  const features = [{
    icon: <Users size={32} data-id="element-260" />,
    title: 'Full-Service Experts',
    description: 'From weekly mowing to full hardscape installations — one team handles everything. No subcontractors, no runaround.'
  }, {
    icon: <MapPin size={32} data-id="element-261" />,
    title: 'Locally Based',
    description: 'We live and work in San Diego County. We know the area, the climate, and what your yard needs to thrive.'
  }, {
    icon: <MessageSquare size={32} data-id="element-262" />,
    title: 'Clear Communication',
    description: "You'll always know what's happening. We respond fast, explain everything clearly, and never leave you guessing."
  }, {
    icon: <DollarSign size={32} data-id="element-263" />,
    title: 'Honest Pricing',
    description: 'Every estimate is free and transparent. What we quote is what you pay — no surprises, no hidden fees.'
  }, {
    icon: <ShieldCheck size={32} data-id="element-264" />,
    title: 'Quality Guaranteed',
    description: "We don't consider a job done until you're completely satisfied. Your property is our reputation."
  }, {
    icon: <Clock size={32} data-id="element-265" />,
    title: 'We Show Up On Time',
    description: 'We respect your time. We schedule it, we show up for it. Simple as that.'
  }];
  return <section className="py-20 bg-primary" data-id="element-266">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
        <div className="text-center mb-16" data-id="element-268">
          <span className="text-white/80 font-bold tracking-wider text-sm uppercase mb-3 block" data-id="element-269">
            WHY YEI MATEO LAWN CARE
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-270">
            One Team. Every Service. Zero Headaches.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12" data-id="element-271">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-start" data-id="element-272">
              <div className="bg-white/10 p-4 rounded-xl text-accent mb-6" data-id="element-273">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-274">
                {feature.title}
              </h3>
              <p className="text-white/80 leading-relaxed" data-id="element-275">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}